import { render } from "./DetailDove.vue?vue&type=template&id=347d3a0b&scoped=true"
import script from "./DetailDove.vue?vue&type=script&lang=js"
export * from "./DetailDove.vue?vue&type=script&lang=js"

import "./DetailDove.vue?vue&type=style&index=0&id=347d3a0b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-347d3a0b"

export default script